import React, { useState, useMemo } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './ui/command';
import { Button } from './ui/button';
import { ChevronsUpDown, Check, Star, Clock } from 'lucide-react';

// Combobox pesquisável de colaboradores: favoritos (⭐) primeiro, depois alfabético
export const ColaboradorCombobox = ({ colaboradores, value, onChange, allowNone = true, testId = 'colaborador-select' }) => {
  const [open, setOpen] = useState(false);
  const ordenados = useMemo(
    () => [...colaboradores].sort(
      (a, b) => ((b.favorito ? 1 : 0) - (a.favorito ? 1 : 0)) || a.nome.localeCompare(b.nome)
    ),
    [colaboradores]
  );
  const selected = colaboradores.find((c) => c.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          className="w-full justify-between font-normal"
          data-testid={testId}
        >
          <span className={`flex items-center gap-1.5 truncate ${selected ? '' : 'text-gray-500'}`}>
            {selected?.favorito && <Star size={13} className="fill-yellow-400 text-yellow-500 shrink-0" />}
            {selected ? selected.nome : 'Escalar depois (deixar em branco)'}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Digite o nome do colaborador..." />
          <CommandList>
            <CommandEmpty>Nenhum colaborador encontrado.</CommandEmpty>
            <CommandGroup>
              {allowNone && (
                <CommandItem
                  value="Escalar depois"
                  data-testid="colab-escalar-depois"
                  onSelect={() => { onChange(''); setOpen(false); }}
                >
                  <Check className={`mr-2 h-4 w-4 ${!value ? 'opacity-100' : 'opacity-0'}`} />
                  <Clock size={14} className="mr-1.5 text-gray-400" />
                  Escalar depois
                </CommandItem>
              )}
              {ordenados.map((c) => (
                <CommandItem
                  key={c.id}
                  value={c.nome}
                  data-testid={`colab-option-${c.id}`}
                  onSelect={() => { onChange(c.id); setOpen(false); }}
                >
                  <Check className={`mr-2 h-4 w-4 ${value === c.id ? 'opacity-100' : 'opacity-0'}`} />
                  {c.favorito
                    ? <Star size={14} className="mr-1.5 fill-yellow-400 text-yellow-500 shrink-0" />
                    : <span className="mr-1.5 w-[14px] shrink-0" />}
                  {c.nome}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
